import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_PERMISSION } from '@/constant/ListPermission';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';

import Permission from './index';
import store from '@/store';

export function permissionWar(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();
  const verifyPermission = PermissionClass.can(LIST_PERMISSION.WAR);
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  const hasAccess = verifyPermission || isPlanFree;

  if (hasAccess) {
    next();
    return;
  }

  next({ name: 'Dashboard' }); 
}
